import API from '@/API/request';

export const newApplicationFormApi = {
    // 获取活动编号
    getActivityCode: (params) => API.get('/activity/code', params),
    // 获取活动分类列表
    getActivityList: (params) => API.post('/config/sys_dictionary', params),
    // 获取活动分类列表
    updateActivity: (params) => API.post('/activity/update_market_activity', params),
    // 获取模板活动列表
    getTemplateActivity: (params) => API.get(`/config/template_activity/version/${params}`),
    // 获取总部活动列表
    getHeadquarterActivity: (params) => API.get(`/config/headquarter_activity/version/${params}`),
    // 获取活动类型和细分活动类型
    getActivityType: (params) => API.get(`/config/activity_type/${params}`),
    // 根据模板活动获取议程
    getTemplateActivityAgenda: (params) => API.get(`/config/template_activity_agenda/${params}`),
    // 获取财务体系列表
    getFinancialSystemList: (params) => API.get(`/config/financial_system/list/${params}`),
    // 获取货币种类列表
    getCurrencyList: (params) => API.get('/config/currency/list', params),
    // 获取申请人列表
    getSalesmanList: (params) => API.get(`/config/salesman/list/10/${params}`),
    // 获取渠道签约类型列表 1-国际 | 0国内
    getChannelTypeList: (params) => API.get(`/config/qd/type/${params}`),
    // 获取渠道名称列表
    getChannelNameList: (params) => API.post('/config/qd/name', params),
    // 获取国际渠道名称列表
    getInternationalNameList: (params) => API.post('/config/qd/international/name', params),
    // 获取业务单元列表
    getUnitNameList: (params) => API.get(`/config/unit_name_list/${params}`),
    // 编辑回显
    getMarketActivityData: (params) => API.get(`/activity/market_activity/${params}`),
    // 获取报备编辑回显
    getReportData: (params) => API.get(`/report/market_activity_detail/${params}`),
    // 获取审批规则
    getApproveRule: (params) => API.get(`/config/sys_dictionary/ApproveRule/${params}`),
    // 获取客商列表
    getCustomerList: (params) => API.post('/customer/selection', params),
    // 添加客商合规检验
    verificationCustomer: (params) => API.post('compliance-verification/customer', params),
    // 获取业务机会名称
    getBusinessName: (params) => API.get(`/customer/API_MARKET_CRM_OPP/${params}/1000/1`),
    // 获取行业和议程的组合列表
    getIndustryAgendaList: () => API.get('/config/industry_agenda'),
    // 根据主办方获取活动类型 1.全部 2.主办型 3.参与型
    getActivityTypeList: (params) => API.get(`/config/sys_dictionary/activity_type/${params}`),

    // 获取财务体系跟货币种类列表
    getFinancialList: (params) => API.get(`/config/financial-system/list/${params}`),
    // 获取费用归属部门列表
    getExpenseDeptList: (params) => API.post(`/expense_relate/expense_dept_list`, params),
    // 获取费用类型列表
    getExpenseTypeList: (params) => API.get(`/expense_relate/expense_type_list/${params}`),
    // 获取细分市场列表
    getMarketList: (params) => API.get(`/expense_relate/market/${params}`),
    // 获取产品线列表
    getProductLineList: (params) => API.get(`/expense_relate/dictionary_list`),
    // 获取预算余额外币
    getRealBudgetBalance: ({ deptCode, expenseTypeCode, currentFinancialSystem, localCurrencyCode }) => API.get(`/expense_relate/rate/real-budget/${deptCode}/${expenseTypeCode}/${currentFinancialSystem}/${localCurrencyCode}`),
    // 获取预算余额
    getBudgetBalance: ({ deptCode, expenseTypeCode }) => API.get(`/config/budget/balance/${deptCode}/${expenseTypeCode}`),
    // 获取省份列表
    getProvinceList: (params) => API.get(`/config/gift/province_city/${params}`),
    // 获取城市区县列表
    getCityList: ({ type, code }) => API.get(`/config/gift/province_city/${type}/${code}`),
    // 获取活动费用选项列表
    getExpenseOptionList: (params) => API.get(`/config/expense_detail_item`),

    // 广告品新接口
    // 广告品分类列表
    getGiftClassify: (params) => API.get(`/gift/category${params ? '/' + params : ''}`),
    // 广告品商品列表
    getGiftList: (params) => API.post('/gift/list', params),
    // 判断商品是否可售
    judgeSold: (params) => API.post('/gift/check', params),
    toolKitModification: (params) => API.post('/report/update_report_activity', params),
    // 广告品旧接口
    // 广告品分类列表
    // getGiftClassify: (params) => API.get(`/config/gift/classify/price_range`),
    // // 广告品商品列表
    // getGiftList: (params) => API.post('/config/gift/list', params),

    // 获取文件上传token
    getFileToken: (params) => API.get('/file/token', params),

    // 新建申请提交
    activityFormSubimt: (params) => API.post('activity/market_activity', params),
    verificationActivity: (params) => API.post('compliance-verification/market-activity', params),
    // 新建申请提交增加标识
    getExpCode: (params) => API.get('/expense_relate/exp-code', params),
    // 新建申请提交增加标识
    getDetailsAll: (params) => API.get(`/activity/gift/order/details/all/${params.eventCode}/${params.expCode}`),
    // 报备申请提交 | 保存草稿
    getGiftUrl: (params) => API.post('/activity/gift/gift-url', params),
    // 草稿编辑删除费用归属
    deleteExpense: (params) => API.delete(`/expense_relate/expense/${params.eventCode}/${params.expCode}`),
    // 草稿编辑删除费用归属
    deleteOrderCode: (params) => API.delete(`/activity/gift/del-order/${params.eventCode}/${params.orderCode}`),
    // 保存草稿
    activityFormSave: (params) => API.put('activity/market_activity', params),
    // 追加费用
    additionalExpense: (params) => API.put('/activity/expense/addition', params),
    // 报备追加费用
    reportAdditionalExpense: (params) => API.put('/activity/expense/report/addition', params),
    // 获取活动负责人列表
    getChargeman: (params) => API.get(`/config/chargeman/list/10/${params}`),
    // 报备申请提交 | 保存草稿
    reportSubimt: (params) => API.post('activity/market_activity/report', params),
    // 新活动报备提交
    reportNewSubmit: (params) => API.post('/report/submit  ', params),
    // 取消报备
    cancelReport: (activityCode) => API.put(`/report-approve/cancel/${activityCode}`),
    // 区域名称
    getRegionName: () => API.get('/report/region'),
    // 校验是否有imc权限
    checkUserIsImc: (params) => API.post('/activity/apply/checkUserIsImc', params),
    // 获取区域费用归属单场费用上限
    queryRemainAvailableAmount: (activityCode) => API.get('/report/queryRemainAvailableAmount?activityCode=' + activityCode),
    // 获取行业报备面向行业选择值
    queryTargetIndustry: (activityCode) => API.get('/report/queryTargetIndustry?activityCode=' + activityCode)
};

export const locationManagementApi = {
    // 获取地址列表
    getAddressList: (params) => API.get('/gift/address/list'),
    // 获取国家列表地址
    getOverseasAddress: (params) => API.get(`gift/getOverseasAddress/${params}`),
    // 新增收货地址
    addAddress: (params) => API.post('/gift/address', params),
    // 编辑收货地址
    editAddress: (params) => API.put('/gift/address', params),
    // 设置默认地址
    setDefaultAddress: (params) => API.put(`/gift/address/default/${params}`),
    // 删除地址
    deleteAddress: (params) => API.delete(`/gift/address/${params}`)
};

// 活动规则
export const activityRuleApi = {
    // 更新规则
    updateRule: (params) => API.post('/activity/apply/updateRule', params),
    // 添加规则
    addRule: (params) => API.post('/activity/apply/addRule', params),
    // 删除规则
    delById: (params) => API.get(`/activity/apply/delById?id=${params}`),
    // 获取规则详情
    getById: (params) => API.get(`/activity/apply/getById?id=${params}`),
    // 查询规则
    matchRule: (params) => API.post('/activity/apply/matchRule', params)
};
